import { createFileRoute } from "@tanstack/react-router";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { HIRE_SHOPIFY_DEVELOPER_COPY } from "@/lib/hire-shopify-developer-copy";

const PATH = "/hire-shopify-developer";
const ALT = "/es/contratar-desarrollador-shopify";
const COPY = HIRE_SHOPIFY_DEVELOPER_COPY.en;

export const Route = createFileRoute("/hire-shopify-developer")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Hire a Shopify Developer | Senior Shopify Engineering · Shugert",
    description: "Hire senior Shopify developers for themes, Functions, checkout, apps, integrations, migrations, performance and technical SEO with staging and documented handoff.",
    path: PATH,
    altPath: ALT,
    jsonLd: [
      breadcrumbJsonLd([
        { name: "Home", path: "/" },
        { name: "Services", path: "/services" },
        { name: "Hire a Shopify Developer", path: PATH },
      ]),
      faqJsonLd(COPY.faqs),
      serviceJsonLd({
        name: "Shopify Engineering Capacity",
        description: "Senior Shopify engineering capacity for recurring or interconnected implementation work with written scope, staging, verification and handoff.",
        path: PATH,
        serviceType: "Shopify Developer",
        minPrice: 1500,
        unit: "PROJECT",
        deliverables: [
          "Written scope and acceptance criteria",
          "Senior Shopify implementation",
          "Representative QA and release controls",
          "Technical documentation and handoff",
        ],
        locale: "en",
      }),
      webPageJsonLd({
        name: "Hire a Shopify Developer",
        path: PATH,
        description: "Add senior Shopify engineering capacity without losing ownership, release control or technical context.",
        inLanguage: "en-US",
      }),
    ],
  }),
});
